import * as React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const UserCheckFilled = (props: IconProps) => (
    <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M15.9849 17.2244V26.4854H5.48486C5.48474 25.1611 5.76641 23.852 6.31117 22.645C6.85593 21.438 7.65131 20.3607 8.64445 19.4848C9.63759 18.6088 10.8058 17.9542 12.0714 17.5645C13.337 17.1748 14.671 17.0588 15.9849 17.2244ZM14.8182 15.9854C10.9507 15.9854 7.8182 12.8529 7.8182 8.98535C7.8182 5.11785 10.9507 1.98535 14.8182 1.98535C18.6857 1.98535 21.8182 5.11785 21.8182 8.98535C21.8182 12.8529 18.6857 15.9854 14.8182 15.9854ZM21.5767 24.0517L25.7009 19.9275L27.3517 21.5772L21.5767 27.3522L17.4514 23.2269L19.1022 21.5772L21.5755 24.0517H21.5767Z" fill={props.color || "#000"} />
    </svg>


)
export default UserCheckFilled
